import React from 'react';
import {SimpleGrid} from '@chakra-ui/react';
import {useDispatch, useSelector} from 'react-redux';
import {Col, Row, UiBox, UiImage, UiQuestionnaireLayout, UiText} from '~/components/elements';
import {ScrollToBottomButton} from '~/components/shared/ScrollToBottomButton';
import {ACNE_TELECONSULTATION_KEYS, NONE_OF_THE_ABOVE_VALUE} from '~/constants/medical-questionnaires';
import {useInput} from '~/hooks';
import {setNextQuestionnaire, setQuestionnaireAnswer} from '~/redux/questionnaires/slice';
import {RootState} from '~/redux/root-reducer';
import {AppDispatch} from '~/redux/root-store';
import {spacing} from '~/utils/theme/spacing';

const Questionnaire8Screen = () => {
  const dispatch: AppDispatch = useDispatch();
  const medicalQuestionnaire = useSelector((state: RootState) => state.questionnaires.medicalQuestionnaire);

  const questionnaires = medicalQuestionnaire?.questionnaires;
  const questionnaire = questionnaires?.find(i => i.key === ACNE_TELECONSULTATION_KEYS.HAVE_SIDE_EFFECTS_OR_ALLERGIC);
  const currentAnswer = useSelector(
    (state: RootState) =>
      state.questionnaires?.collectData[ACNE_TELECONSULTATION_KEYS.HAVE_SIDE_EFFECTS_OR_ALLERGIC]?.data,
  );
  const {inputs, setInputs} = useInput<{selectedOptions: string[]}>({
    selectedOptions: currentAnswer?.selectedOptions || [],
  });

  const onClickSubmit = () => {
    dispatch(
      setQuestionnaireAnswer({
        key: ACNE_TELECONSULTATION_KEYS.HAVE_SIDE_EFFECTS_OR_ALLERGIC,
        index: questionnaire?.index || '',
        data: inputs,
      }),
    );
    dispatch(setNextQuestionnaire({value: ACNE_TELECONSULTATION_KEYS.ON_ACNE_OR_SKIN_TREATMENT}));
  };

  const onClickOption = (valueOption: string) => {
    if (inputs.selectedOptions.includes(valueOption)) {
      setInputs({
        selectedOptions: inputs.selectedOptions?.filter(el => el !== valueOption),
      });
    } else {
      setInputs({
        selectedOptions: [...inputs.selectedOptions.filter(el => el !== NONE_OF_THE_ABOVE_VALUE), valueOption],
      });
    }
  };

  const onClickNone = () => {
    setInputs({selectedOptions: [NONE_OF_THE_ABOVE_VALUE]});
  };

  return (
    <UiQuestionnaireLayout
      handleOnNext={onClickSubmit}
      checkoutStep={questionnaire?.checkoutStep}
      actions={questionnaire?.actions}
      disableNext={!inputs.selectedOptions.length}
    >
      <Col align="center" textAlign="center">
        <UiImage type="icon" name={questionnaire?.icon} boxSize={spacing.mLarge} mt={spacing.small} />
        <UiText fontSize="xl" fontWeight="bold" mt={spacing.medium}>
          {questionnaire?.questions?.default}
        </UiText>
        <SimpleGrid columns={2} mt={5} spacing={5} w="100%">
          {questionnaire?.options
            ?.filter(el => el.value !== NONE_OF_THE_ABOVE_VALUE)
            ?.map(value => (
              <UiBox key={`${value.label}-${value.value}`}>
                <ScrollToBottomButton
                  key={`${value.label}-${value.value}`}
                  title={value.label}
                  variant={inputs.selectedOptions?.includes(value.value as string) ? 'solid' : 'toggle'}
                  onClick={() => onClickOption(value.value as string)}
                  height="35px"
                  w="100%"
                />
              </UiBox>
            ))}
        </SimpleGrid>
        <Row justify="center" mt={8} w="100%">
          <ScrollToBottomButton
            title="None of the above"
            variant={!!inputs.selectedOptions.includes(NONE_OF_THE_ABOVE_VALUE) ? 'solid' : 'toggle'}
            onClick={onClickNone}
            height="35px"
            minW="50%"
          />
        </Row>
      </Col>
    </UiQuestionnaireLayout>
  );
};

export default Questionnaire8Screen;
